"use client";

import { Rating as DSRating } from "@pamperedchef/design-system";
import * as styles from "./Rating.module.scss";

export interface RatingProps {
	/** Star value out of 5. */
	value: number;
	size?: "large" | "small";
}

/**
 * Thin wrapper over the design-system `Rating` that derives the accessible
 * label from the numeric value. Shared by testimonials and any future
 * review surfaces on the landing page.
 */
export function Rating({ value, size = "small" }: RatingProps) {
	return (
		<div className={styles["rating"]} data-component="Rating">
			<DSRating
				rating={value}
				label={`${value.toFixed(1)} out of 5 stars`}
				size={size}
			/>
		</div>
	);
}
